<div
  class="toaster-notifications-container flex flex-col w-[30rem] space-y-1 fixed right-0 top-0 m-3"
>
  @for (toasterNotification of toasterNotifications; track toasterNotification)
  {
  <er-toaster-notification
    [notificationTitle]="toasterNotification.title"
    [notificationMessage]="toasterNotification.message"
    [notificationType]="toasterNotification.type"
    (closeNotification)="closeNotification(toasterNotification)"
    (autoCloseNotification)="closeNotification(toasterNotification)"
    [@fade]
  >
  </er-toaster-notification>
  }
</div>
